import React, { useEffect, useState } from "react";
import "./ContactComponents.css";
import DojangInfo from "./DojangInfo";
import MapPlaceholder from "./MapPlaceholder";
import { sanityClient } from "../../../sanity/client";
import { locationsQuery } from "../../../sanity/queries";

const FindDojang = () => {
  const [dojangs, setDojangs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    sanityClient.fetch(locationsQuery).then(setDojangs);
  }, []);

  if (!dojangs.length) return null;

  return (
    <div className="find-dojang-card">
      <div className="dojang-header">
        <h2>
          Encuentra tu <span className="stroke-text">Dojang</span>
        </h2>

        <div className="dojang-tabs">
          {dojangs.map((dojang, index) => (
            <button
              key={dojang._id}
              className={`dojang-tab ${index === activeIndex ? "active" : ""}`}
              onClick={() => setActiveIndex(index)}
            >
              {dojang.name}
            </button>
          ))}
        </div>
      </div>

      <DojangInfo data={dojangs[activeIndex]} />
      <MapPlaceholder location={dojangs[activeIndex]} />
    </div>
  );
};

export default FindDojang;
